import { paginationFragment } from './fragments/pagination';

const fragment = `
  id
  name
  url
  mappedFields
  createdAt
  lastSubmittedAt
  formSubmissionsCount
  isMapped
  entityType
  communities {
    id
    name
  }
  projects {
    id
    name
  }
  models {
    id
    name
  }
  buildingModels {
    id
    name
  }
`;

export const listFormsQuery = `
  query ListForms(
    $filter: FormFilterInput
    $page: Int
    $pageSize: Int
  ) {
    result: listForms(filter: $filter, page: $page, pageSize: $pageSize) {
      items {
        ${fragment}
      }
      pagination {
        ${paginationFragment}
      }
    }
  }
`;

export const getFormQuery = `
  query GetForm($id: Int!) {
    item: getForm(id: $id) {
      ${fragment}
    }
  }
`;

export const createFormMutation = `
  mutation CreateForm(
    $input: CreateFormInput!
  ) {
    item: createForm(input: $input) {
      ${fragment}
    }
  }
`;

export const updateFormMutation = `
  mutation UpdateForm(
    $input: UpdateFormInput!
  ) {
    item: updateForm(input: $input) {
      ${fragment}
    }
  }
`;

export const deleteFormMutation = `
  mutation DeleteForm($id: Int!) {
    item: deleteForm(id: $id) {
      ${fragment}
    }
  }
`;
